import type { CardProps } from "../types/components.js";

const spacing = {
  none: "p-0",
  compact: "p-4",
  default: "p-5 sm:p-6",
  roomy: "p-5 sm:p-6 lg:p-7",
};

export function Card({ children, className = "", padding = "default", ...props }: CardProps) {
  return (
    <section
      className={`min-w-0 rounded-2xl border border-border bg-background text-foreground ${spacing[padding]} ${className}`}
      {...props}
    >
      {children}
    </section>
  );
}
